export default __webpack_public_path__ + "static/filewithgolddust-7e9f29a58265ae8a65082c5441e55f49.png";